<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { permissionsMixin } from '@/mixins/userPermissions';

export default {
  inject: ['setLoading', 'auth'],
  mixins: [permissionsMixin],
  data() {
    return {
     errors: {}, 
     id: '',
     name: '',
     code: '',
     email: '',
     mobile: '',
     address: '',
     latitude: '',
     longitude: '',
     radius_meters: '',
     fetchingLocation: false,
    };
  },


  mounted() {
    this.setPermissions(this.auth);
  },
  computed: {
    canSeeLocation() {
      return this.getPermission('HRMS_Setup', 'read');
    },
  },

  methods: {

    getCurrentLocation() {
  if (!navigator.geolocation) {
    this.$swalToast('Your browser does not support geolocation.', 'error');
    return;
  }

  this.fetchingLocation = true;

  navigator.geolocation.getCurrentPosition(
    (position) => {
      this.latitude = position.coords.latitude.toFixed(7);
      this.longitude = position.coords.longitude.toFixed(7);

      // Set a default radius if it's empty
      if (this.radius_meters === '') this.radius_meters = 100;

      this.fetchingLocation = false;
      this.$swalToast('Location fetched successfully.');
    },
    (error) => {
      this.fetchingLocation = false;
      let msg = 'Unable to fetch location.';
      if (error.code === error.PERMISSION_DENIED) {
        msg = 'Location permission denied. Please allow location access in your browser settings.';
      } else if (error.code === error.POSITION_UNAVAILABLE) {
        msg = 'Location information is unavailable.';
      } else if (error.code === error.TIMEOUT) {
        msg = 'Location request timed out. Please try again.';
      }
      this.$swalToast(msg, 'error');
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    }
  );
},
  
   branch(row = null) {
    this.resetForm();
    if(row != null){
     this.setLoading(true);    
     try{
      this.id = row.id;
      this.name = row.name;
      this.code = row.code;
      this.email = row.email;
      this.mobile = row.mobile;
      this.address = row.address;
      this.latitude = row.latitude ?? '';
      this.longitude = row.longitude ?? '';
      this.radius_meters = row.radius_meters ?? '';
     }finally{
      this.setLoading(false);
     } 
     
    }
   },  

   async saveBranch(){
    this.errors = {};
    this.setLoading(true); 

    try{
     const payload = {
      id: this.id,
      name: this.name,
      code: this.code,
      email: this.email,
      mobile:  this.mobile,
      address: this.address  
     };

    if (this.canSeeLocation) {
       payload.latitude = this.latitude === '' ? null : this.latitude;
       payload.longitude = this.longitude === '' ? null : this.longitude;
       payload.radius_meters = this.radius_meters === '' ? null : this.radius_meters;
     }

     let response = [];
     if(this.id){
      response = await axios.put(`/branches/${this.id}/update`, payload);  
     }else{
      response = await axios.post(`/branches/create`, payload);  
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.closeModal('branch_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteBranch(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/branches/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
    this.closeModal('delete_modal');
   }finally{
    this.setLoading(false);
   }
  }, 

  async removeFile(){
   const result = await this.$confirm({});
    if(result.isConfirmed){ 
   this.setLoading(true);
   try{
    const response = await axios.delete(`/banks/${this.id}/image/remove`);
    this.$swalToast(response.data.message);
    this.$emit('updated'); 
    this.closeModal('branch_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
   }
  },

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.code = '';
   this.email = '';
   this.mobile = '';
   this.address = '';
   this.latitude = '';
   this.longitude = '';
   this.radius_meters = '';
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="branch_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Branch</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="saveBranch" enctype="multipart/form-data">
          <div class="modal-body pb-0">
            <div class="row">
              
              <div class="col-md-8">
                <div class="mb-3">
                  <label class="form-label">Branch Name</label>
                  <input type="text" class="form-control" v-model="name" />
                  <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Branch Code</label>
                  <input type="text" class="form-control" v-model="code" />
                  <div v-if="errors.code" class="text-danger small mt-1">{{ errors.code[0] }}</div>
                </div>
              </div>

              <div class="col-md-8">
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input type="text" class="form-control" v-model="email" />
                  <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
                </div>
              </div> 

              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Mobile No</label>
                  <input type="text" class="form-control" v-model="mobile" />
                  <div v-if="errors.mobile" class="text-danger small mt-1">{{ errors.mobile[0] }}</div>
                </div>
              </div> 

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Address</label>
                  <input type="text" class="form-control" v-model="address" />
                  <div v-if="errors.address" class="text-danger small mt-1">{{ errors.address[0] }}</div>
                </div>
              </div> 

              <!-- Location / Geofencing — HRMS permission only -->
              <template v-if="canSeeLocation">
              <div class="col-12">
                <div class="br-geo-head d-flex align-items-center justify-content-between">
                  <div>
                    <i class="ti ti-map-pin me-1"></i>Location / Geofencing
                    <span class="br-geo-note">(used for attendance check-in)</span>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    :disabled="fetchingLocation"
                    @click="getCurrentLocation"
                  >
                    <span v-if="fetchingLocation" class="spinner-border spinner-border-sm me-1"></span>
                    <i v-else class="ti ti-current-location me-1"></i>
                    {{ fetchingLocation ? 'Fetching...' : 'Get Location' }}
                  </button>
                </div>
              </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Latitude</label>
                    <input type="number" step="any" class="form-control" v-model="latitude" placeholder="e.g. 28.6267" />
                    <div v-if="errors.latitude" class="text-danger small mt-1">{{ errors.latitude[0] }}</div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Longitude</label>
                    <input type="number" step="any" class="form-control" v-model="longitude" placeholder="e.g. 77.2173" />
                    <div v-if="errors.longitude" class="text-danger small mt-1">{{ errors.longitude[0] }}</div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Radius (meters)</label>
                    <input type="number" step="1" min="0" class="form-control" v-model="radius_meters" placeholder="e.g. 100" />
                    <div v-if="errors.radius_meters" class="text-danger small mt-1">{{ errors.radius_meters[0] }}</div>
                  </div>
                </div>
              </template>
              
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteBranch">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>

<style scoped>
.br-geo-head {
  font-size: 12px; font-weight: 700; color: #475569;
  padding: 8px 0; margin-bottom: 6px; border-top: 1px dashed #e2e8f0;
}
.br-geo-head i { color: #6366f1; }
.br-geo-note { font-size: 10.5px; font-weight: 400; color: #94a3b8; margin-left: 4px; }
</style>